import RotatingTitleParagraphComponent from "./rotating-title-paragraph-component";
import RotatingTitleParagraphConfig from "./rotating-title-paragraph-config";
import RotatingTitleParagraphAdvancedConfig from "./rotating-title-paragraph-advanced-config";

export default {
  RotatingTitleParagraphComponent,
  RotatingTitleParagraphConfig,
  RotatingTitleParagraphAdvancedConfig
};
